import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { FunctionDefinition, FunctionDefinitionUpdate } from '../models/function-definition.model';
import { FunctionRun } from '../models/function-run.model';
import { SyncServiceSummary } from '../models/sync-service.model';

@Injectable({
  providedIn: 'root',
})
export class SyncServicesApiService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.apiUrl.replace(/\/$/, '');

  getSyncServices(): Observable<SyncServiceSummary[]> {
    return this.http.get<SyncServiceSummary[]>(`${this.api}/sync-services`);
  }

  getDefinition(name: string): Observable<FunctionDefinition> {
    return this.http.get<FunctionDefinition>(`${this.api}/function-definitions/${encodeURIComponent(name)}`);
  }

  updateDefinition(name: string, update: FunctionDefinitionUpdate): Observable<FunctionDefinition> {
    return this.http.put<FunctionDefinition>(`${this.api}/function-definitions/${encodeURIComponent(name)}`, update);
  }

  setDefinitionEnabled(name: string, isEnabled: boolean): Observable<FunctionDefinition> {
    return this.http.patch<FunctionDefinition>(
      `${this.api}/function-definitions/${encodeURIComponent(name)}/enabled`,
      { isEnabled },
    );
  }

  runDefinition(name: string): Observable<FunctionRun> {
    return this.http.post<FunctionRun>(`${this.api}/function-definitions/${encodeURIComponent(name)}/runs`, {});
  }
}
